module.exports = __webpack_public_path__ + "img/story_slide_1.e260782b.jpg";